import { Z_INDEX } from './z-index';

/** 모달 전체가 공유하는 전역 stacking context. Toast/Loading은 이 Host보다 위에 둔다. */
export const MODAL_HOST_Z_INDEX = Z_INDEX.modalHost;
const MODAL_HOST_ATTRIBUTE = 'data-s-modal-host';

type ModalStackEntry = {
  id: number;
  layerIndex: number;
};

let nextId = 0;
let nextLayerIndex = 0;
const entries: ModalStackEntry[] = [];

/**
 * 모든 모달 Portal이 공유하는 DOM Host를 반환한다.
 * Host 자체만 전역 z-index를 가지며, 모달 깊이는 Host 내부에서만 관리한다.
 */
export function getModalHost(): HTMLElement | undefined {
  if (typeof document === 'undefined' || !document.body) return undefined;

  const existing = document.body.querySelector<HTMLElement>(`[${MODAL_HOST_ATTRIBUTE}]`);
  if (existing) return existing;

  const host = document.createElement('div');
  host.setAttribute(MODAL_HOST_ATTRIBUTE, '');
  Object.assign(host.style, {
    position: 'fixed',
    inset: '0',
    zIndex: String(MODAL_HOST_Z_INDEX),
    pointerEvents: 'none',
  });
  document.body.appendChild(host);
  return host;
}

export function registerModalStackEntry(): {
  layerIndex: number;
  isTop: () => boolean;
  unregister: () => void;
} {
  const entry: ModalStackEntry = {
    id: ++nextId,
    layerIndex: nextLayerIndex++,
  };
  entries.push(entry);

  let registered = true;
  return {
    layerIndex: entry.layerIndex,
    isTop: () => entries[entries.length - 1] === entry,
    unregister: () => {
      if (!registered) return;
      registered = false;
      const index = entries.indexOf(entry);
      if (index !== -1) entries.splice(index, 1);
    },
  };
}
